import { Banner, Button } from "@shopify/polaris";

const RenderError = ({ submitErrors }: { submitErrors: { message: string }[] }) => {
    return submitErrors?.length ? (
        <div
            style={{
                maxWidth: "100%",
                width: "100%",
                margin: "auto",
                marginBottom: 14,
            }}
            id="submitErrors"
        >
            <Banner title="Fields Required" tone="critical">
                <div style={{ paddingLeft: "18px", paddingBottom: "10px" }}>
                    <ul>
                        {submitErrors.map(({ message }, index) => {
                            return <li key={`${message}${index}`}>{message}</li>;
                        })}
                    </ul>
                </div>

                <Button variant="secondary" onClick={() => window.kefi_chat.open()}>
                    Contact Support
                </Button>
            </Banner>
        </div>
    ) : (
        <></>
    );
};

export default RenderError;
